import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordRecovery } from '../services/authService';
import TopBar from './TopBar';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await sendPasswordRecovery(email);
      setSuccess(true);
    } catch (err) {
      console.error('Password recovery error:', err);
      if (err.code === 404) {
        setError('No account found with this email address.');
      } else {
        setError(err.message || 'Failed to send recovery email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <TopBar />

      {/* Main Content */}
      <main className="main-content">
        <div className="forgot-password-container">
          {!success ? (
            <>
              <div className="title-section">
                <h1 className="title">Reset Password</h1>
                <p className="subtitle">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
              </div>

              {error && <div className="error-message">{error}</div>}

              <form onSubmit={handleSubmit} className="forgot-password-form">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-input"
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <div className="form-footer">
                <Link to="/login" className="back-link">
                  ← Back to login
                </Link>
              </div>
            </>
          ) : (
            <div className="success-container">
              <div className="success-icon">✉️</div>
              <h1 className="title">Check Your Email</h1>
              <p className="subtitle">
                We've sent a password reset link to <strong>{email}</strong>
              </p>
              <p className="hint">
                Didn't receive the email? Check your spam folder or{' '}
                <button 
                  className="link-button"
                  onClick={() => setSuccess(false)}
                >
                  try again
                </button>
              </p>
              <Link to="/login" className="back-link">
                ← Back to login
              </Link>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ForgotPasswordPage;
